<div class="fk-dialog">
  <h2 mat-dialog-title>Add Foreign Key</h2>

  <mat-dialog-content>
    <div *ngIf="error" class="fk-error">{{ error }}</div>

    <form [formGroup]="form">
      <div class="fk-row">
        <mat-form-field appearance="outline" class="fk-field">
          <mat-label>Source Table</mat-label>
          <input matInput
                 [formControl]="sourceTableSearch"
                 [matAutocomplete]="sourceTableAuto"
                 placeholder="Type to search…" />
          <mat-autocomplete #sourceTableAuto="matAutocomplete" [displayWith]="displayTableOption" (optionSelected)="onTableSelected($event, 'source')">
            <mat-option *ngFor="let o of filteredSourceTableOptions" [value]="o">{{ o.label }}</mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline" class="fk-field">
          <mat-label>Target Table</mat-label>
          <input matInput
                 [formControl]="targetTableSearch"
                 [matAutocomplete]="targetTableAuto"
                 placeholder="Type to search…" />
          <mat-autocomplete #targetTableAuto="matAutocomplete" [displayWith]="displayTableOption" (optionSelected)="onTableSelected($event, 'target')">
            <mat-option *ngFor="let o of filteredTargetTableOptions" [value]="o">{{ o.label }}</mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="fk-row">
        <mat-form-field appearance="outline" class="fk-field">
          <mat-label>Key Alias</mat-label>
          <input matInput formControlName="keyAlias" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="fk-field">
          <mat-label>Display Name</mat-label>
          <input matInput formControlName="displayName" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="fk-field">
          <mat-label>Display Name (Plural)</mat-label>
          <input matInput formControlName="displayNamePlural" />
        </mat-form-field>
      </div>

      <div class="fk-section-header">
        <strong>Field Pairs</strong>
        <button type="button" mat-button (click)="addPair()">+ Add Field Pair</button>
      </div>

      <div class="fk-hint" *ngIf="!sourceFieldOptions.length || !targetFieldOptions.length">
        Choose a source and target table to pick GUID field pairs (only GUID-typed fields can be used in a foreign key).
      </div>

      <div formArrayName="fieldPairs">
        <div *ngFor="let pair of fieldPairs.controls; let i = index" [formGroupName]="i" class="fk-pair-row">
          <mat-form-field appearance="outline" class="fk-field">
            <mat-label>Source Field</mat-label>
            <mat-select formControlName="sourceFieldId">
              <mat-option *ngFor="let o of sourceFieldOptions" [value]="o.value">{{ o.label }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="fk-field">
            <mat-label>Target Field</mat-label>
            <mat-select formControlName="targetFieldId">
              <mat-option *ngFor="let o of targetFieldOptions" [value]="o.value">{{ o.label }}</mat-option>
            </mat-select>
          </mat-form-field>

          <button type="button" mat-icon-button color="warn" [disabled]="fieldPairs.length <= 1" (click)="removePair(i)" aria-label="Remove pair">
            &times;
          </button>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close(false)">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="form.invalid || saving" (click)="save()">
      {{ saving ? 'Saving…' : 'Save' }}
    </button>
  </mat-dialog-actions>
</div>
